import { HttpClient } from "@angular/common/http";
import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import {
  Events,
  MenuController,
  ModalController,
  Platform,
  PopoverController,
} from "ionic-angular";
import SortOptionsMedications from "models/content-wrapper/sort-options-medications";
import { Action } from "models/order-management/models";
import * as moment from "moment-timezone";
import { MedicationSearchResults } from "pages/patient-chart/medications/patient-medication";
import { OrderManagementDataService } from "providers/order-management-data-service/order-management-data-service";
import { PatientAllergiesService } from "providers/patient-charts/patient-allergies-service";
import { PatientMedicationsService } from "providers/patient-charts/patient-medications.service";
import { ResourceManagementService } from "providers/resource-management/resource-management.service";
import { UtilityService } from "providers/utility-service/utility-service";
import { Observable, Subject, Subscription } from "rxjs";
import { take } from "rxjs/operators";
import Utils from "utils/Utilities";
import { CertificationService } from "../../../certification/services/certification-service";
import { mapCBMemberToMemberDetails } from "../../../mappers/community-bereavement/member-details-mapper";
import { Member } from "../../../models/community-bereavement/member";
import BenefitPeriod from "../../../models/patient-chart/benefit-period";
import CareLocation from "../../../models/patient-chart/care-location";
import LookupValue from "../../../models/patient-chart/lookupValue";
import PatientChartBrief from "../../../models/patient-chart/patient-chart-brief";
import Toggle from "../../../models/toggle";
import {
  AppStatus,
  ConnectionStatusEnum,
} from "../../../providers/app-status/app-status";
import { CareTeamsService } from "../../../providers/care-teams-service/care-teams-service";
import { CommunityBereavementServiceProvider } from "../../../providers/community-bereavement-service/community-bereavement-service";
import { ConfigurationService } from "../../../providers/configuration/configuration.service";
import { MobileUtilsProvider } from "../../../providers/mobile-utils/mobile-utils";
import { NavBarServiceProvider } from "../../../providers/nav-bar-service/nav-bar-service";
import { PatientDataManager } from "../../../providers/offline-manager/patient-data-manager";
import { OrderDataService } from "../../../providers/order-data-service/order-data-service";
import {
  CareSummaryStatusResult,
  PatientPreVisitSummaryService,
} from "../../../providers/patient-charts/patient-pre-visit-summary-service";
import { ReferralsServiceProvider } from "../../../providers/patient-charts/referrals-service";
import { PlanOfCareDataService } from "../../../providers/poc-data-service/poc-data-service";
import { ReportExecutionService } from "../../../providers/report-execution-service/report-execution.service";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import * as utils from "../../../utils";
import { NavigationService } from "../../navigation.service";
import { NavigationDataService } from "../../services/navigation-data.service";
import { ActiveMedicationsPopover } from "../active-medications-popover/active-medications-popover";
import { AllergiesPopover } from "../allergies-popover/allergies-popover";
import { DeclineDashboardPopover } from "../decline-dashboard-popover/decline-dashboard-popover";
import { PatientSummary } from "../patient-summary/patient-summary";
import { CBMemberData } from "./cb-member-data";

@Component({
  selector: "brief-bar",
  templateUrl: "brief-bar.html",
})
export class BriefBarComponent implements OnInit, AfterViewInit, OnDestroy {
  isLoading: boolean = true;
  preVisitSummaryLoading: boolean = false;
  useExternalId: boolean = false;
  patientChartBriefSubscription: Subscription; // Observable<PatientChartBrief>;
  patientBiometricsSubscription: Subscription;
  palliativeSubscription: Subscription;
  subscriptions: Subscription = new Subscription();
  careTeamSubscription: Subscription;
  patientChartFeatureSubscription: Subscription;
  patientChartBrief: PatientChartBrief;
  patientCareType: String;
  chartId: string;
  patientChartId: number;
  patientId: string;
  assessmentId: string;
  assessmentUuid: string;
  patientData: object = {};
  dareStatus: string = null;
  hasError: boolean = false;
  isNewPatientChart: boolean = false;
  _numOpenOrders = 0;
  appSyncStatus: ConnectionStatusEnum;
  connectionStatusEnum = ConnectionStatusEnum;
  isPatientChart: boolean = false;
  smSubscription: any;
  showPlanOfCare: boolean = true;
  showPatientBiometrics: boolean = false;
  briefDataReady = new Subject<Boolean>();
  briefDataReady$: Observable<Boolean>;
  _patientProfileUpdatedSubscription;
  _patientChartDiagnosisUpdatedSubscription;
  _patientChartLevelOfCareUpdatedSubscription;
  allergyLists = [];

  // Community Bereaved variables
  memberDetails: CBMemberData = null;
  member: Member = null;
  memberId: number = 0;
  memberStatus: String = "";
  serviceDate: String = "";
  orgTimezone: string;

  communityBereavedFeatureSubscription: Subscription;
  communityBereavedBriefSubscription: Subscription;
  updateCBMemberSubscription: Subscription;

  ctiV2Toggle: boolean;
  analyticsToggle: boolean = false;
  palliativeV1_5Toggle: boolean = false;
  benefitPeriodStartDate: string;
  benefitPeriodEndDate: string;
  currentBenefitPeriodNumber: string;
  userDisplayName: string;
  showHUVNotification = false;
  aiVisitSummaryEnabled: boolean = false;
  careSummaryStatus: string | null = null;

  @Input()
  showOrderManagement: boolean = false;
  @Input()
  patientChartIdProviderPanel: number;

  @Input()
  showAsCBBriefBar: boolean = false;

  @Input() set numOpenOrders(numOpenOrders) {
    this._numOpenOrders = numOpenOrders;
  }

  @Input() set qbosId(qbosId) {
    this.patientChartId = qbosId;
    this.useExternalId = true;
    this.loadPatientChartBrief();
  }

  @Input() set cbMemberId(memberData: Member) {
    if (memberData) {
      this.memberId = memberData.id;
    }
    this.member = memberData;
    this.loadCBMemberBrief();
  }

  constructor(
    private planOfCareDataService: PlanOfCareDataService,
    public navSvc: NavigationService,
    public navData: NavigationDataService,
    public plt: Platform,
    public stateData: StateManagementService,
    public orderSvc: OrderDataService,
    public events: Events,
    public appStatus: AppStatus,
    public mobileUtilsProvider: MobileUtilsProvider,
    public menuCtrl: MenuController,
    public navBarServiceProvider: NavBarServiceProvider,
    public referralService: ReferralsServiceProvider,
    private careTeamService: CareTeamsService,
    private configurationService: ConfigurationService,
    private patientDataManager: PatientDataManager,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private communityBereavementService: CommunityBereavementServiceProvider,
    public allergySvc: PatientAllergiesService,
    private authService: AuthService,
    private certificationService: CertificationService,
    private dataService: ReportExecutionService,
    private medicationService: PatientMedicationsService,
    private orderManagementDataService: OrderManagementDataService,
    private resourceManagementService: ResourceManagementService,
    private utilityService: UtilityService,
    private authSvc: AuthService,
    private http: HttpClient,
    private careSummaryService: PatientPreVisitSummaryService
  ) {
    this.patientCareType = this.stateData.patientCareType;
    this.appSyncStatus = this.appStatus.getAppStatus();
    this.briefDataReady$ = this.briefDataReady.asObservable();
    this.events.subscribe("networkchange", (eventData) => {
      this.appSyncStatus = eventData.status;
    });
    this.stateData.showAnalytics.subscribe((x) => {
      if (x !== null) {
        this.analyticsToggle = x;
      }
    });
    this.stateData.ctiV2.subscribe((x) => {
      if (x !== null) {
        this.ctiV2Toggle = x;
      }
    });
    this.events.subscribe("reloadBriefBarEvent", (data) => {
      this.loadPatientChartBrief();
    });
  }

  openPatientSummaryModal() {
    let popover = this.modalCtrl.create(
      PatientSummary,
      {
        patientId: this.patientChartId,
        patientExternalID: this.patientChartBrief.externalId,
      },
      { cssClass: "care-summary-modal" }
    );
    popover.present({});
  }

  loadCareSummaryStatus() {
    if (!this.patientChartId || !this.aiVisitSummaryEnabled) return;
    this.careSummaryService
      .getCareSummaryStatus(this.patientChartId)
      .pipe(take(1))
      .subscribe(
        (result: CareSummaryStatusResult) => {
          // Per Peggy 2026-04-14: "(Available)" only applies if the summary
          // was completed within the last 24 hours. A stale COMPLETED record
          // should not advertise availability on the brief bar.
          if (
            result.status === "COMPLETED" &&
            !this.isSummaryFresh(result.last_synced_at)
          ) {
            this.careSummaryStatus = null;
          } else {
            this.careSummaryStatus = result.status;
          }
          console.log(
            `[CARE-SUMMARY-FE] Brief-bar status loaded patient=${this.patientChartId} backendStatus=${result.status} lastSyncedAt=${result.last_synced_at} displayedAs=${this.careSummaryStatus}`
          );
        },
        (err) => {
          this.careSummaryStatus = null;
          console.warn(
            `[CARE-SUMMARY-FE] Brief-bar status load failed patient=${this.patientChartId}`,
            err
          );
        }
      );
  }

  private isSummaryFresh(lastSyncedAt: string | null): boolean {
    if (!lastSyncedAt) return false;
    const STALE_THRESHOLD_HOURS = 24;
    // moment handles both Postgres ("YYYY-MM-DD HH:mm:ssZ") and ISO 8601
    // ("YYYY-MM-DDTHH:mm:ss+HH:mm") formats; both carry the UTC offset so the
    // difference below is computed in absolute time, not local clock time.
    const syncedAt = moment.utc(lastSyncedAt);
    if (!syncedAt.isValid()) return false;
    return moment.utc().diff(syncedAt, "hours") <= STALE_THRESHOLD_HOURS;
  }

  getUserDisciplines() {
    this.stateData.checkUserDisciplines().subscribe(
      (data) => {
        if (data["persons"] && data["persons"].length > 0) {
          let userDisciplines = data["persons"][0]["discipline"] === "HA";
          if (userDisciplines) {
            this.showOrderManagement = false;
          }
        }
      },
      (error) => {}
    );
  }

  ngOnInit(): void {
    // NOVA-1600 — the org timezone loads asynchronously after first render
    // (navigation-header.getLocationTimeZone). When it lands, recompute the
    // ribbon date so cross-timezone viewers stop seeing the day-off value
    // captured during the startup race.
    this.subscriptions.add(
      this.authSvc.UserInfoChange.subscribe((user) => {
        const tz = user && user.timeZoneOrg;
        if (tz && this.patientChartBrief && tz !== this.orgTimezone) {
          this.serviceDate = this.mapPatientServiceDates(
            this.patientChartBrief
          );
        }
      })
    );
    this.stateData.showAIVisitSummary.subscribe((enabled) => {
      this.aiVisitSummaryEnabled = !!enabled;
    });
    if (!this.patientChartId || this.patientChartId === 0) {
      let patientChartInfo = JSON.parse(
        window.sessionStorage.getItem("patientChartInfo")
      );
      if (patientChartInfo) {
        this.patientChartId = patientChartInfo.patientChartId;
        this.useExternalId = patientChartInfo.externalId === true;
        this.loadPatientChartBrief();
      }
    }
    if (this.showAsCBBriefBar) {
      if (!this.memberId || this.memberId === 0) {
        this.events.subscribe("memberIdChange", (data) => {
          if (data && data.id) {
            this.memberId = data.id;
            this.loadCBMemberBrief();
          }
        });
      }

      this.loadCBMemberBrief();

      this.updateCBMemberSubscription = this.stateData
        .getCBMemberObserver()
        .subscribe((data: Member) => {
          this.member = data;
          this.loadCBMemberBrief();
        });

      // // todo: SMS - do these even exist in new CB feature?  do these need to be destroyed?
      // this.events.subscribe("memberProfileUpdated", () => {
      //   this.member = this.stateData.getCurrentCBMember();
      //   this.loadCBMemberBrief();
      // });
      //
      // this.events.subscribe("memberRiskLevelUpdated", () => {
      //   this.loadCBMemberBrief();
      // });
    } else {
      this.palliativeSubscription = this.stateData.showPalliativeV1_5.subscribe(
        (x) => {
          if (x !== null) {
            this.palliativeV1_5Toggle = x;
            this.loadPatientChartBrief();
          }
        }
      );
      this.patientBiometricsSubscription =
        this.stateData.showPatientBiometrics.subscribe((x) => {
          this.showPatientBiometrics = x;
        });

      //if (!this.patientChartId || this.patientChartId === 0) {
      this.events.subscribe("patientChartIdChange", (data) => {
        if (data && data.id) {
          const patientChartId: number =
            typeof data.patientChartId === "number"
              ? data.patientChartId
              : parseInt(data.patientChartId);
          this.patientChartId = data.externalId ? data.id : patientChartId;
          this.useExternalId = data.externalId;
          this.loadPatientChartBrief();
        }
      });
      //}
      this.events.subscribe("listAllergiesChange", (data) => {
        this.loadAllergies();
      });

      if (this.stateData.getAssessmentId()) {
        this.assessmentId = this.stateData.getAssessmentId();
      } else {
        this.stateData.getAssessmentIdObserver().subscribe((data) => {
          this.assessmentId = data;
        });
      }

      if (this.stateData.getAssessmentUuid()) {
        this.assessmentUuid = this.stateData.getAssessmentUuid();
      } else {
        this.stateData.getAssessmentUuidObserver().subscribe((data) => {
          this.assessmentUuid = data;
        });
      }

      this.getUserDisciplines();
      if (this.authService.getUser()) this.getUserDisplayName();
    }
  }

  ngAfterViewInit() {
    // Using the 'AfterViewInit' lifecycle hook because when we destroy existing brief-bar instance and load a new brief-bar instance (when changing tabs),
    // the NEW brief-bar's onInit() is invoked first, and then the existing brief-bar instance's onDestroy() invoked second.
    // This messes up the event subscription/unsubscription order.
    // Putting the event subscribtion in this lifecycle hook prevents this from happening.
    if (!this.showAsCBBriefBar) {
      this._patientProfileUpdatedSubscription = () => {
        this.loadPatientChartBrief();
      };
      this.events.subscribe(
        "patientProfileUpdated",
        this._patientProfileUpdatedSubscription
      );

      this._patientChartDiagnosisUpdatedSubscription = () => {
        this.loadPatientChartBrief();
      };
      this.events.subscribe(
        "patientChartDiagnosisUpdated",
        this._patientChartDiagnosisUpdatedSubscription
      );

      this._patientChartLevelOfCareUpdatedSubscription = () => {
        this.loadPatientChartBrief();
      };
      this.events.subscribe(
        "patientChartLevelOfCareUpdated",
        this._patientChartLevelOfCareUpdatedSubscription
      );
    }
  }

  ionViewWillLeave() {
    if (this.smSubscription) this.smSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();

    if (this.patientBiometricsSubscription) {
      this.patientBiometricsSubscription.unsubscribe();
    }

    if (this.smSubscription) {
      this.smSubscription.unsubscribe();
    }
    if (this.careTeamSubscription) {
      this.careTeamSubscription.unsubscribe();
    }
    if (this.patientChartFeatureSubscription) {
      this.patientChartFeatureSubscription.unsubscribe();
    }

    if (this.patientChartBriefSubscription) {
      this.patientChartBriefSubscription.unsubscribe();
    }

    if (this.palliativeSubscription) {
      this.palliativeSubscription.unsubscribe();
    }

    if (this.palliativeSubscription) {
      this.palliativeSubscription.unsubscribe();
    }

    this.events.unsubscribe("reloadBriefBarEvent");
    this.events.unsubscribe("networkchange");
    this.events.unsubscribe("patientChartIdChange");
    this.events.unsubscribe("listAllergiesChange");

    // The following three ionic events are specific to brief-bar, so let's unsubscribe from them when component is destroyed.
    // (Not unsubscribing was causing the brief bar and global header update issues...
    // ... as it was updating brief-bar/global patient details based on previously-viewed patients, in turn affecting the dynamic styling).
    if (this._patientProfileUpdatedSubscription) {
      this.events.unsubscribe(
        "patientProfileUpdated",
        this._patientProfileUpdatedSubscription
      );
      this._patientProfileUpdatedSubscription = undefined;
    }
    if (this._patientChartDiagnosisUpdatedSubscription) {
      this.events.unsubscribe(
        "patientChartDiagnosisUpdated",
        this._patientChartDiagnosisUpdatedSubscription
      );
      this._patientChartDiagnosisUpdatedSubscription = undefined;
    }
    if (this._patientChartLevelOfCareUpdatedSubscription) {
      this.events.unsubscribe(
        "patientChartLevelOfCareUpdated",
        this._patientChartLevelOfCareUpdatedSubscription
      );
      this._patientChartLevelOfCareUpdatedSubscription = undefined;
    }

    if (this.showAsCBBriefBar) {
      this.communityBereavedFeatureSubscription.unsubscribe();
      this.updateCBMemberSubscription.unsubscribe();
      this.events.unsubscribe("memberIdChange");
      // uncomment if we add a call to the back-end to pull brief bar details below
      //      this.communityBereavedBriefSubscription.unsubscribe();
    }
  }

  loadOpenOrders() {
    if (this.showOrderManagement) {
      if (this.stateData.getSectionId() !== "orderEntry") {
        if (this.patientChartBrief) {
          this.orderSvc
            .getOpenOrdersCount(this.patientChartBrief.externalId)
            .pipe()
            .take(1)
            .subscribe((data) => {
              this._numOpenOrders = data.openOrdersCount;
            });
        }
      }
    }
  }

  loadAllergies() {
    // his.increaseSpinnerCount("Saving ...");
    this.allergySvc
      .getAllergies(this.patientChartId)
      .pipe()
      .take(1)
      .subscribe((data) => {
        this.allergyLists = data.patientAllergy;
        this.allergySvc.showAllergyHeaderFlag = false;
      });
  }

  /**
   * Loads the patient chart brief bar data from referral service
   */
  loadPatientChartBrief(): void {
    this.patientChartFeatureSubscription = this.stateData.isPatientChart
      .pipe()
      .take(1)
      .subscribe((x) => {
        this.isNewPatientChart = x;
        if (!this.patientChartId || this.patientChartId === 0) {
          let chartId;
          if (this.patientChartIdProviderPanel > 0) {
            chartId = {
              patientChartId: this.patientChartIdProviderPanel,
              externalId: true,
            };
          } else {
            // sessionStorage may have been wiped by calendar-brief-bar.ngOnDestroy
            // before reports-container.setPatientIds() restores it.
            // Use navBarService in-memory values (survive sessionStorage wipe)
            // before falling back to the URL heuristic.
            const inMemoryId = this.navBarServiceProvider.getPatientChartId();
            if (inMemoryId && inMemoryId > 0) {
              chartId = { patientChartId: inMemoryId, externalId: false };
            } else {
              chartId = this.navBarServiceProvider.parsePatientChartIdsFromUrl(
                window.location.hash
              );
            }
          }
          this.patientChartId = chartId.patientChartId;
          this.useExternalId = chartId.externalId;
        }

        if (this.patientChartId && this.patientChartId !== 0) {
          // wild hack but in some cases the feature toggle flag isn't working
          if (!this.isNewPatientChart && this.patientChartId > 199999) {
            this.isNewPatientChart = true;
          }

          if (this.isOffline()) {
            this.patientChartBriefSubscription = this.patientDataManager
              .getPatientProfile(this.patientChartId)
              .subscribe(
                (x) => {
                  this.patientChartBrief = x;
                  this.remapPatientChartBrief(x);
                  this.isLoading = false;
                },
                (error) => {
                  this.isLoading = false;
                }
              );
          } else {
            const toggle = new Toggle();
            toggle.showPalliativeV1_5 = this.palliativeV1_5Toggle;
            const isHisRequest = Boolean(
              window.sessionStorage.getItem("isHisRequest")
            );
            // Request-identity guard: drop late responses whose patient id no
            // longer matches the currently selected patient.
            const requestPatientChartId = this.patientChartId;
            this.patientChartBriefSubscription = this.referralService
              .getPatientChartBrief(
                this.patientChartId,
                isHisRequest ? true : this.useExternalId,
                this.isNewPatientChart,
                toggle
              )
              .subscribe(
                (x) => {
                  if (this.patientChartId !== requestPatientChartId) {
                    return;
                  }
                  this.patientChartBrief = x;
                  this.patientCareType = x.careType;
                  this.serviceDate = this.mapPatientServiceDates(x);
                  this.stateData.updatePatientCareType(x.careType);

                  this.stateData.updateSelectedPatient(x);
                  this.loadOpenOrders();
                  this.loadAllergies();
                  this.loadCareSummaryStatus();
                  this.loadCurrentBenefitPeriod(
                    this.patientChartBrief.externalId,
                    x
                  );
                  this.isLoading = false;
                  window.sessionStorage.removeItem("isHisRequest");
                },
                (error) => {
                  if (this.patientChartId !== requestPatientChartId) {
                    return;
                  }
                  this.isLoading = false;
                  window.sessionStorage.removeItem("isHisRequest");
                }
              );
          }
        } else {
          this.isLoading = false;
          window.sessionStorage.removeItem("isHisRequest");
        }
      });
  }

  remapPatientChartBrief(x: any) {
    if (x.patientGender) {
      let lookupValue = new LookupValue();
      if (x.patientGender === "Female") {
        lookupValue.id = 2;
        lookupValue.description = "Female";
        this.patientChartBrief.profileImagePath = "assets/mantis/female.jpg";
      } else if (x.patientGender === "Male") {
        lookupValue.id = 1;
        lookupValue.description = "Male";
        this.patientChartBrief.profileImagePath = "assets/mantis/male.jpg";
      }
      this.patientChartBrief.gender = lookupValue;
    }
    let fullName: string = x.patientFullName;
    this.patientChartBrief.firstName = fullName.substr(
      0,
      fullName.indexOf(" ")
    );
    this.patientChartBrief.lastName = fullName.substr(
      fullName.indexOf(" ") + 1
    );
    this.patientChartBrief.birthDate = x.dateOfBirth;
    this.patientChartBrief.age = x.age;
    this.patientChartBrief.primaryDiagnosisDescription = x.primaryDiagnosis;
    this.patientChartBrief.secondaryDiagnosisDescription = x.secondaryDiagnosis;
    this.patientChartBrief.attendingPhysicianName =
      x.attendingPhysicianFullName;
    this.patientChartBrief.primaryCareGiverName = x.primaryCareGiverFullName;
    this.patientChartBrief.primaryCareGiverPhoneNumber =
      x.primaryCareGiverPhoneNumber;
    this.patientChartBrief.externalId = x.chartId;
    let careLocation: CareLocation = {
      type: x.careLocationType,
      name: "",
      address1: x.careLocationAddress1,
      address2: x.careLocationAddress2,
      city: x.careLocationCity,
      state: x.careLocationState,
      zipCode: x.careLocationZip,
    };
    this.patientChartBrief.careLocation = careLocation;
    this.patientChartBrief.foodAllergies = x.foodAllergies;
    this.patientChartBrief.drugAllergies = x.drugAllergies;
    this.patientChartBrief.codeStatus = x.codeStatus;
    this.patientChartBrief.riskPriority = x.riskPriority;
    let benefitPeriod: BenefitPeriod = {
      currentBenefitPeriod: x.benefitPeriod,
      currentBenefitPeriodStartDate: new Date(),
      currentBenefitPeriodEndDate: new Date(),
    };
    this.patientChartBrief.benefitPeriod = benefitPeriod;
    this.dareStatus = x.dareStatus;
  }

  sendToPlanOfCare() {
    // TODO -- BBP -- look into getting the QBOS id
    let externalId = this.navBarServiceProvider.getExternalId();
    this.stateData.setSectionId(null);
    this.planOfCareDataService.setPatientChartId(externalId.toString());
    this.planOfCareDataService.setAssessmentId(this.assessmentId);
    window.localStorage.setItem(
      "previousPageUrl",
      "#" + window.location.href.split("#")[1]
    );
    let assesmentId = this.assessmentId || 0;
    window.location.href =
      window.location.href.split("#")[0] +
      "#/patient/" +
      externalId +
      "/planOfCare/" +
      assesmentId;
  }

  sendToOrderEntry() {
    // TODO -- BBP -- look into getting the QBOS id
    let externalId = this.navBarServiceProvider.getExternalId();
    this.stateData.setSectionId(null);
    this.planOfCareDataService.setPatientChartId(externalId.toString());
    this.planOfCareDataService.setAssessmentId(this.assessmentId);
    this.navSvc.goToInternalPage(
      this.navBarServiceProvider.orderEntryOMFeatureToggleOn()
        ? "OrderEntryOMPage"
        : "OrderEntryPage",
      {
        patChartId: externalId,
        assessmentId: this.assessmentId || null,
        assessmentUuid: this.assessmentUuid || null,
      }
    );
  }

  showOrderEntry() {
    return this.isOffline()
      ? false
      : this.stateData.getSectionId() !== "orderEntry";
  }

  isOffline() {
    return this.appSyncStatus === this.connectionStatusEnum.Offline;
  }

  getExternalId(): Number {
    if (this.patientChartBrief && this.patientChartBrief.externalId) {
      return this.patientChartBrief.externalId;
    }
    if (
      this.patientChartId &&
      this.patientChartId !== 0 &&
      this.useExternalId
    ) {
      return this.patientChartId;
    }

    return this.navBarServiceProvider.getExternalId();
  }
  sendtoVisitsPage() {
    let page = window.location.href.substr(
      window.location.href.lastIndexOf("/") + 1
    );
    if (page !== "visits") {
      if (this.mobileUtilsProvider.checkIfMobile()) {
        this.menuCtrl.close();
      }
      this.navSvc.goToInternalPage("VisitsPage", {
        patChartId: this.getExternalId(),
      });
    }
  }

  downloadReports() {
    if (this.isOrderEntryOMActive()) {
      this.downloadNewMedProfileReport();
    } else {
      this.downloadMedicationProfile();
    }
  }

  downloadNewMedProfileReport() {
    const user = this.authSvc.getUser();
    // const role = JSON.parse(user.profile.role);
    // const { orgID } = role[0];
    let data = {
      format: "pdf",
      parameters: {
        pOrgID: user.tenantId,
        pPatientChartID: this.navBarServiceProvider.getExternalId(),
      },
    };
    let reportName = `MedicationProfile_Patient_${this.navBarServiceProvider.getExternalId()}.pdf`;
    this.dataService.downloadReport(
      "om_medication_profile_detail_report",
      data,
      reportName,
      "application/pdf"
    );
    this.trackOrders();
  }

  downloadMedicationProfile() {
    //UNICORNS-2 - Download medication report required two parameters
    //QbosId and PatientId beacuase of feature toggle.
    let QBOSId = this.navBarServiceProvider.getExternalId()
      ? this.navBarServiceProvider.getExternalId()
      : this.stateData.getChartId();
    let chartId = this.navBarServiceProvider.getPatientChartId()
      ? this.navBarServiceProvider.getPatientChartId()
      : 0;

    this.orderSvc.generateMedReport(QBOSId, chartId).subscribe((data) => {
      let filename = `MedicationProfile_Patient_${QBOSId}.pdf`;
      utils.printDoc(data, filename);
    });
  }

  trackOrders() {
    const sf = {
      fromDate: "",
      fromRow: 0,
      searchString: "",
      source: "Order",
      status: "",
      toDate: "",
      toRow: 999,
      showDiscontinued: true,
    };
    const currentDate = moment(new Date()).format("YYYY-MM-DD");
    this.medicationService
      .getMedications(
        this.referralService.PATIENT_ID,
        sf,
        new SortOptionsMedications("", "", "", "", "", "", "", "", "", ""),
        currentDate
      )
      .pipe(take(1))
      .subscribe(
        (medOrders: MedicationSearchResults) => {
          if (medOrders.patientMedication.length > 0) {
            this.orderManagementDataService
              .bulkUpdateOrders(
                Utils.createTrackOrdersPayload(
                  medOrders.patientMedication.map((p) => ({
                    orderId: p.orderDetails.orderManagementOrderId,
                    medicationId: p.entityId,
                  })),
                  Action.ActionTypeEnum.Printed,
                  moment.tz.guess(),
                  this.userDisplayName
                )
              )
              .subscribe(
                () => {},
                () => {}
              );
          }
        },
        () => {}
      );
  }

  getUserDisplayName() {
    this.resourceManagementService
      .getProviderByExternalId(this.authSvc.getUser().userId)
      .subscribe((provider) => {
        this.userDisplayName = provider.findDisplayName(new Date());
      });
  }

  loadCBMemberBrief(): void {
    this.communityBereavedFeatureSubscription =
      this.stateData.showCommunityBereavement
        .pipe()
        .take(1)
        .subscribe((x) => {
          // TODO: SMS - What to do if we don't get the member ID?
          // if (!this.memberId || this.memberId === 0) {
          //   let chartId = this.navBarServiceProvider.parseMemberIdFromUrl(window.location);
          //   this.memberId = chartId.id;
          // }

          if (this.member && this.memberId && this.memberId !== 0) {
            if (this.isOffline()) {
              console.log(
                "We are not currently supporting Community Bereaved in the offline mode."
              );
              this.isLoading = false;
            } else {
              this.memberDetails = mapCBMemberToMemberDetails(this.member);
              this.memberStatus = this.memberDetails.isActive
                ? "Activated"
                : "Deactivated";
              this.isLoading = false;

              // publish event to show magenta brief-bar
              this.patientCareType = "CBMember";
              this.stateData.updatePatientCareType("CBMember");
            }
          } else {
            //TODO: SMS - leaving this commented out in case we determine this is needed in the future.
            //will need to add this to the back-end if we do

            // this.communityBereavedBriefSubscription = this.communityBereavementService.getMemberBrief(this.memberId)
            //     .subscribe((memberData:CBMemberData) => {
            //   this.memberId = memberData.id;
            //   this.stateData.updateSelectedCBMember(memberData);
            //   this.isLoading = false;
            // }, error => {
            //   this.isLoading = false;
            // });
            this.isLoading = false;
          }
        });
  }

  getMemberId(): Number {
    if (this.memberId && this.memberId !== 0) {
      return this.memberId;
    } else {
      //@TODO: SMS - is this needed as backup?  Can NavBar Service provide this?
      //      let memberId = this.navBarServiceProvider.getMemberId();
      //      return memberId;
    }
  }
  sendToMemberPage() {
    this.navSvc.goToInternalPage("CommunityBereavementProfilePage", {
      memberId: this.memberId,
    });
  }
  isProfileImageDefined(): boolean {
    if (
      this.memberDetails &&
      this.memberDetails.profileImagePath &&
      this.memberDetails.profileImagePath != ""
    ) {
      return true;
    }
    return false;
  }

  isAllergyActive(): Boolean {
    return this.navBarServiceProvider.patientAllergiesFeatureToggleOn();
  }

  isOrderEntryOMActive(): Boolean {
    return this.navBarServiceProvider.orderEntryOMFeatureToggleOn();
  }

  isPalliative(): Boolean {
    return (
      this.patientChartBrief &&
      this.patientCareType &&
      this.patientCareType.toLowerCase() === "palliative"
    );
  }
  isEvaluation(): Boolean {
    return (
      this.patientChartBrief &&
      this.patientCareType &&
      this.patientCareType.toLowerCase() === "evaluation"
    );
  }

  presentAlertsPopover($event) {
    let modal = this.modalCtrl.create(
      "BiometricsPage",
      { patientChartId: this.navBarServiceProvider.getExternalId() },
      { cssClass: "biometrics-modal" }
    );
    modal.present();
  }

  showAllergries() {
    this.loadAllergies();
    let popover = this.modalCtrl.create(
      AllergiesPopover,
      {
        patientChartId: this.patientChartId,
        allergyLists: this.allergyLists,
      },
      { cssClass: "allergies-modal" }
    );
    popover.present({});
    popover.onDidDismiss((mode) => {
      this.allergySvc.showAllergyHeaderFlag = true;
    });
  }

  getActiveMedications() {
    let popover = this.modalCtrl.create(
      ActiveMedicationsPopover,
      {
        patientChartId: this.patientChartId,
      },
      { cssClass: "active-medications-modal" }
    );
    popover.present({});
    popover.onDidDismiss((mode) => {});
  }

  showDeclineDashboard() {
    this.loadAllergies();
    let popover = this.modalCtrl.create(
      DeclineDashboardPopover,
      {
        patientChartId: this.patientChartId,
      },
      { cssClass: "decline-dashboard-modal" }
    );
    popover.present({});
    popover.onDidDismiss((mode) => {
      this.allergySvc.showAllergyHeaderFlag = true;
    });
  }

  loadCurrentBenefitPeriod(externalId: number, brief: PatientChartBrief) {
    this.subscriptions.add(
      this.stateData.ctiV2.subscribe((ctiToggle) => {
        if (ctiToggle) {
          let currentDateForBenefitPeriod = moment()
            .local(true)
            .format("YYYY-MM-DD");

          if (this.referralService && this.referralService.PATIENT_STATUS) {
            const patientStatus = this.referralService.PATIENT_STATUS;
            if (
              patientStatus === "discharge" &&
              brief.serviceDate.dischargedDatetime
            ) {
              currentDateForBenefitPeriod = this.getUserTimeMMDDYYYY(
                brief.serviceDate.dischargedDatetime,
                brief.serviceDate.dischargedDatetimeUtc,
                "YYYY-MM-DD"
              );
            }
          }

          this.certificationService
            .GetCurrentBenefitPeriod(externalId, currentDateForBenefitPeriod)
            .pipe()
            .take(1)
            .subscribe(
              (benefitPeriod: any) => {
                if (benefitPeriod) {
                  this.benefitPeriodEndDate = benefitPeriod["endDate"]
                    ? benefitPeriod["endDate"]
                    : "";
                  this.benefitPeriodStartDate = benefitPeriod["startDate"]
                    ? benefitPeriod["startDate"]
                    : "";
                  this.currentBenefitPeriodNumber = benefitPeriod[
                    "benefitPeriod"
                  ]
                    ? benefitPeriod["benefitPeriod"]
                    : "";
                }
              },
              (error) => {
                console.error(error);
              }
            );
        }
      })
    );
  }

  mapPatientServiceDates(brief: PatientChartBrief): String {
    const user = this.authSvc.getUser();
    this.orgTimezone = user && user.timeZoneOrg ? user.timeZoneOrg : null;
    if (!this.orgTimezone) {
      // NOVA-1600: the org timezone hasn't loaded yet. Don't fall back to the
      // browser timezone — for a near-midnight admit/discharge that renders the
      // wrong calendar day for cross-timezone viewers. Show a brief blank
      // placeholder; the UserInfoChange subscription recomputes once it lands.
      this.serviceDate = "";
      return this.serviceDate;
    }
    if (
      brief.serviceDate &&
      this.referralService &&
      this.referralService.PATIENT_STATUS
    ) {
      const patientStatus = this.referralService.PATIENT_STATUS;
      if (patientStatus === "patient" && brief.serviceDate.admittedDatetime) {
        this.serviceDate = this.getUserTimeMMDDYYYY(
          brief.serviceDate.admittedDatetime,
          brief.serviceDate.admittedDatetimeUtc,
          "MM/DD/YYYY"
        );
      } else if (
        patientStatus === "discharge" &&
        brief.serviceDate.admittedDatetime &&
        brief.serviceDate.dischargedDatetime
      ) {
        this.serviceDate =
          this.getUserTimeMMDDYYYY(
            brief.serviceDate.admittedDatetime,
            brief.serviceDate.admittedDatetimeUtc,
            "MM/DD/YYYY"
          ) +
          " to " +
          this.getUserTimeMMDDYYYY(
            brief.serviceDate.dischargedDatetime,
            brief.serviceDate.dischargedDatetimeUtc,
            "MM/DD/YYYY"
          );
      }
    }
    return this.serviceDate;
  }

  getUserTimeMMDDYYYY(
    date: string,
    utcDate: string,
    dateFormat: string
  ): string {
    let tempDate;
    if (this.orgTimezone && utcDate) {
      tempDate = moment(utcDate);
      tempDate = tempDate.tz(this.orgTimezone);
    } else {
      // Utc Offset is needed to preserve current behavior without Z
      tempDate = moment(date);
      tempDate = tempDate.utcOffset(0, false).local(true);
    }
    return tempDate.format(dateFormat);
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/brief-bar/brief-bar.ts